<template>
    <div class="w100" style=" background: #01033c;">
        <article class="content-bg" style="padding-top: 40px;">
            <div class="logo-position">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
            </div>
            <div class="logo-position textRight" style="right: 60px; left: auto;">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
            </div>
            <div class="wContent center">
                <div class="textCenter">
                    <img src="../../assets/images/ej/activity_boxing/2023.png" alt="" srcset="" style="width: 340px;"><br>
                    <img src="../../assets/images/2023/tianjin/name.png" alt="" srcset="" style="width: 770px;" class="mt30">
                    <p class="title-text mt40 fontWhite">2023 · 中国 · 天津</p>
                    <!-- <p class="title-text-en mt10 fontWhite">WITHOUT BOUNDARIES</p> -->
                    <p class="time-text textCenter center mt40">时间： 2023年8月24日，地点： 天津水晶宫饭店</p>
                </div>
                <div class="center meeting-jj">
                    <p class="textCenter meeting-jj-title">会议简介</p>
                    <p>2023年以来，我国经济复苏缓慢，增长压力重重。国内钢铁市场需求不足、钢材高供给压力持续、钢企利润微薄，市场情绪悲观.....。钢材市场弱现实与强预期反复纠缠，市场行情震荡调整。</p>
					<p>“金九”临近，目前市场是否将处于触底反弹的窗口期？金九银十旺季行情能否重现？在这诸多不确定及多变的因素和时间节点，唐宋大数据诚邀业界同仁与行业资深专家齐聚一堂，产业与交易融合，上游与下游对话，探讨价格走势，展望未来经济政策、产业格局，唐宋大数据诚挚地邀请您莅临本次盛会！欢聚天津，共话未来！</p>
				</div>
                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;程</span></p>
                    <div class="meeting-yc-content center mt30">
                        <h2>
                            <span>下午</span><br>
                            <span>8月24日</span>
                        </h2>
						<div class="line"></div>
                        <div>
                            <p class="time-line-content">
                                <span class="fontWhite font14">13:30-14:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">嘉宾签到</span>
                                <a class="shuline" style="height: 50px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:00-14:10</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    致辞<br>
                                    <span class="right-intro"></span>
                            		
                            		<span class="fontWhite font14">
                            		    天津市钢铁工业协会常务副秘书长<br>
                            			<span class="right-intro">时东生先生</span>
                            		</span>
                            		
                            		<br/><br/>
                            		<span class="fontWhite font14">
                            		    天津友发钢管集团有限公司总经理<br>
                            			<span class="right-intro">陈广岭先生</span>
                            		</span>
                            		
                            		<br/><br/>
                            		<span class="fontWhite font14">
                            		    天津荣程联合钢铁集团有限公司副总经理<br>
                            			<span class="right-intro">高玉科先生</span>
                            		</span>
                                </span>
                                <a class="shuline" style="height: 684px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:10-15:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    演讲：《2023下半年钢铁市场形势分析》<br>
                                    <span class="right-intro">河北唐宋大数据产业股份有限公司董事长 宋雷先生</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:00-15:30</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    演讲：《唐宋独特算法分析》<br>
									<span class="right-intro">河北唐宋大数据产业股份有限公司市场研究院副院长 徐向南先生</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:30-16:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    演讲：《市场供需的边际新变化》<br>
                                    <span class="right-intro">上海东亚期货有限公司黑色高级研究员 岳晋琛先生</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
							<p class="time-line-content">
							    <span class="fontWhite font14">16:00-16:10</span>
							    <span class="point"></span>
							    <span class="fontWhite font14">
							        演讲：《2023年钢管行业整体形势分析及展望》<br>
							        <span class="right-intro">天津源泰德润钢管制造集团北方大区经理 陈希萌先生</span>
							    </span>
							    <a class="shuline" style="height: 90px"></a>
							</p>
							<p class="time-line-content">
							    <span class="fontWhite font14">16:10-16:40</span>
							    <span class="point"></span>
							    <span class="fontWhite font14">
							        演讲：《跨境支付新未来》<br>
							        <span class="right-intro">寻汇跨境支付华北大区总监 李云龙先生</span>
							    </span>
							    <a class="shuline" style="height: 90px"></a>
							</p>
							<p class="time-line-content">
							    <span class="fontWhite font14">16:20-17:30</span>
							    <span class="point"></span>
							    <span class="fontWhite font14">
							        市场研讨<br>
							        <span class="right-intro"></span>
									
									<span class="fontWhite font14">
									    唐宋大数据市场研究院副院长<br>
										<span class="right-intro">徐向南先生</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    天津荣程联合钢铁集团有限公司信息部总经理<br>
										<span class="right-intro">任若凡先生</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    成大物产 (厦门)有限公司业务总监<br>
										<span class="right-intro">刘海涛先生</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    天和商业集团大宗商品事业部总经理<br>
										<span class="right-intro">张嘉驿先生</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    唐宋大数据套期保值研究院副院长<br>
										<span class="right-intro">王利雄先生</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    天津中和建业国际贸易有限公司总经理<br>
										<span class="right-intro">陈建华先生</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    寻汇跨境支付华北大区总监<br>
										<span class="right-intro">李云龙先生</span>
									</span>
									
									<br/><br/>
							    </span>
							    <a class="shuline" style="height: 618px"></a>
							</p>
							<p class="time-line-content">
							    <span class="fontWhite font14">18:00-20:00</span>
							    <span class="point"></span>
							    <span class="fontWhite font14">
							        晚宴<br>
							        <span class="right-intro"></span>
							    </span>
							    <!-- <a class="shuline" style="height: 90px"></a> -->
							</p>
                        </div>                        
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;嘉&nbsp;&nbsp;&nbsp;宾&nbsp;&nbsp;&nbsp;介&nbsp;&nbsp;&nbsp;绍</span></p>
					<div class="meeting-jbjs center mt40">
                        <el-row :gutter="20" class="mw-modular-box">
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/2023/tianjin/01宋雷.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司<br/>董事长 宋雷</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/2023/tianjin/02时东升.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">时东升</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/2023/tianjin/03陈广岭.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">天津友发钢管集团有限公司<br/>总经理 陈广岭</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/2023/tianjin/04高玉科.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">天津荣程联合钢铁集团有限公司<br/>副总经理 高玉科</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/2023/tianjin/05源泰代表.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 15px; line-height: 30px; padding: 15px 10px; height: 40px;">源泰代表</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/2023/tianjin/06张嘉驿.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">天和商业集团大宗商品事业部<br/>总经理 张嘉驿</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/2023/tianjin/07岳晋琛.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">上海东亚期货有限公司<br/>黑色高级研究员 岳晋琛</p>
                                </div>
                            </el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/tianjin/08刘海涛.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">成大物产 (厦门)有限公司<br/>业务总监 刘海涛</p>
							    </div>
							</el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/tianjin/09许卫军.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">许卫军</p>
							    </div>
							</el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/tianjin/010李云龙.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">寻汇跨境支付<br/>华北大区总监 李云龙</p>
							    </div>
							</el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/tianjin/011钜宝、恒基代表.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">钜宝、恒基代表</p>
							    </div>
							</el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/tianjin/012陈希萌.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">天津源泰德润钢管制造集团<br/>北方大区经理 陈希萌</p>
							    </div>
							</el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/tianjin/013马树臣.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">马树臣</p>
							    </div>
							</el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/tianjin/014任若凡.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">天津荣程联合钢铁集团有限公司<br/>信息部总经理 任若凡</p>
							    </div>
							</el-col>
                        </el-row>
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;高&nbsp;&nbsp;&nbsp;端&nbsp;&nbsp;&nbsp;访&nbsp;&nbsp;&nbsp;谈</span></p>
                    <div id="marqueeBox" name="marqueeBox" class="index-quote-list-box">
                        <div class="inlineBlock img-box" @click="showImgDetail(0)">
                            <img src="../../assets/images/2023/tianjin/001整体.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(1)">
                            <img src="../../assets/images/2023/tianjin/002任若凡.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(2)">
                            <img src="../../assets/images/2023/tianjin/003刘海涛.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(3)">
                            <img src="../../assets/images/2023/tianjin/004张嘉驿.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(4)">
                            <img src="../../assets/images/2023/tianjin/005王利雄.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(5)">
                            <img src="../../assets/images/2023/tianjin/006陈建华.png" alt="" height="150px">
                        </div>
						<div class="inlineBlock img-box" @click="showImgDetail(6)">
						    <img src="../../assets/images/2023/tianjin/007李云龙.png" alt="" height="150px">
						</div>
                    </div>
                    <el-dialog title="" :visible.sync="dialogVisible" width="40%">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div>
                                    <img :src="dialogImg" alt="" class="w100">
                                </div>
                            </el-col>
                        </el-row>
                    </el-dialog>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;赞&nbsp;&nbsp;&nbsp;助</span></p>
                    <div class="meeting-zanzhu center textCenter">
                        <p class="zanzhu-title mt30">主办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8" :offset="8">
                                <div class="zanzhu-center">河北唐宋大数据产业股份有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">联合主办</p>
                        <el-row :gutter="20" style="display: flex;justify-content: center;">
                            <el-col :span="8">
                                <div class="zanzhu-left">天津源泰德润钢管制造集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">上海东亚期货有限公司</div>
                            </el-col>
                        </el-row>
						
						<p class="zanzhu-subtitle mt30">协办单位</p>
						<el-row :gutter="20" style="display: flex;justify-content: center;">
						    <el-col :span="8">
						        <div class="zanzhu-center">寻汇SUNRATE</div>
						    </el-col>
						</el-row>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;大&nbsp;&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;地&nbsp;&nbsp;&nbsp;点</span></p>
                <div class="meeting-address">
                    <div style="margin-top: 40px" class="mw-modular-box fontWhite textCenter">
                        <h3 style="line-height: 40px; font-size: 24px">天津水晶宫饭店</h3>
                        <p style="line-height: 40px; font-size:24px">天津市河西区友谊路28号</p>
                    </div>
                    <div class="address-bg textCenter">
                        <a href="https://map.baidu.com/search/%E5%A4%A9%E6%B4%A5%E6%B0%B4%E6%99%B6%E5%AE%AB%E9%A5%AD%E5%BA%97/@13047730.715346992,4708026.5846032,19z?querytype=s&da_src=shareurl&wd=%E5%A4%A9%E6%B4%A5%E6%B0%B4%E6%99%B6%E5%AE%AB%E9%A5%AD%E5%BA%97&c=289&src=0&pn=0&sug=0&l=20&b=(13524928.731617035,3663973.3000997417;13525287.584162245,3664164.6040342115)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2" target="_blank">
                            <img src="../../assets/images/2023/tianjin/背景.jpg" alt="" srcset="" class="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;务&nbsp;&nbsp;&nbsp;联&nbsp;&nbsp;&nbsp;系</span></p>
                <div class="meeting-concat center font16 fontWhite mt40">
                    <p class="textCenter" style="line-height: 40px;">
                        河北唐宋大数据产业股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;回执传真至：0315-5921091/92<br>
                        会务联系人：王慧 18231525225&nbsp;&nbsp;&nbsp;&nbsp;路亚旭 15830588702
                    </p>
                    <el-row style="margin-top: 10px; padding-bottom: 30px;">
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/act_code1.png" alt="" width="100px">
                                <small style="display: block;line-height: 40px;">在线监测预警公众号</small>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/02唐宋钢铁APP.jpg" alt="" width="100px">
                                <p style="line-height: 35px;">唐宋APP</p>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/03在线监测预警公众号.jpg" alt="" width="100px">
                                <p style="line-height: 35px;">在线监测预警</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </article>

        <ConcatsControl></ConcatsControl>
    </div>
</template>
<script>
import $ from 'jquery'
import QRCode from 'qrcode'
import '../../assets/js/jquery.liMarquee.js'
import { baseUrl, getQueryString, adIDs } from '../../assets/js/common'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'activitiesDetail2021gz',
    components: { ConcatsControl },
    data() {
        return {
            liMarquee: null,
            dialogVisible: false,
            dialogImg: '',
            imgs: [
                require('../../assets/images/2023/tianjin/001整体.png'),
                require('../../assets/images/2023/tianjin/002任若凡.png'),
                require('../../assets/images/2023/tianjin/003刘海涛.png'),
                require('../../assets/images/2023/tianjin/004张嘉驿.png'),
                require('../../assets/images/2023/tianjin/005王利雄.png'),
                require('../../assets/images/2023/tianjin/006陈建华.png'),
				require('../../assets/images/2023/tianjin/007李云龙.png'),
            ],
            imgsDetailNames: 
            [
                
            ],
            sjDetailData: []
        }
    },
    mounted () {
        this.id = getQueryString('id');
        this.marqueeInit();
    },
    methods: {
        marqueeInit () {
            const self = this;
            $('.index-quote-list-box').liMarquee('destroy');
            setTimeout(() => {
                $('.index-quote-list-box').liMarquee({
                    scrollamount: 120,
                    hoverstop: true,
                    circular: false
                });
            }, 500)
            
            
        },
        showImgDetail (index) {
            this.dialogImg = this.imgs[index];
            this.sjDetailData = this.imgsDetailNames[index];
            this.dialogVisible = true;
        }
    }
    
}
</script>

<style scoped>
    @import url('../../assets/css/liMarquee.css');
    .content-bg {
        background: url('../../assets/images/ej/activeTopbg.jpg') no-repeat;
        background-size: 100% auto;
        position: relative;
    }
    .logo-position {
        position: absolute;
        top: 60px;
        left: 60px;
        color: #fff;
    }
    .logo-position > p { font-size: 20px; }
    .logo-position > div > span { display: inline-block; margin-bottom: 20px; width: 8px; border-top: 2px solid #fff;}
    .mt10 { margin-top: 10px; }
    .mt40 { margin-top: 40px; }
    .mt30 { margin-top: 30px; }
    .title-text { font-size: 28px; letter-spacing: 10px; }
    .title-text-en { font-size: 20px; letter-spacing: 4px; font-weight: 100;}
    .time-text { 
        background: url('../../assets/images/ej/activeTimebg.png') no-repeat; 
        background-size: 100% 100%;
        line-height: 40px;
        width: 600px;
        font-size: 14px;
        font-weight: 600;
    }
    .meeting-jj {
        background: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        color: #fff;
        line-height: 35px;
        width: 700px;
        padding: 20px 30px;
        letter-spacing: 1px;
        margin-top: 60px;
    }
    .meeting-jj-title {
        font-size: 20px;
        margin-bottom: 10px;
    }
    .meeting-yt {
        margin-top: 60px;
    }
    .meeting-yt-title {
        background: url('../../assets/images/ej/activeTitlebg.png') no-repeat;
        background-size: 100% 100%;
        width: 600px;
        height: 60px;
    }
    .meeting-yt-title span {
        background-image: -webkit-linear-gradient(bottom, #ffc67d, #f6c195, #fbdcbf); 
        -webkit-background-clip: text; 
        -webkit-text-fill-color: transparent;
        line-height: 60px;
        font-size: 30px;
        font-weight: 600;
    }
    .meeting-yc-content {
        width: 1000px;
        box-sizing: border-box;
    }
    .meeting-yc-content > h2 {
        border-left: 10px solid #024e9a;
        padding-left: 20px;
        color: #fff;
    }
    .line { border-top: 1px solid #024e9a; margin-top: 10px; }
    .time-line-content { position: relative; margin-top: 40px; }
    .time-line-content span { display: inline-block; font-size: 16px; vertical-align: top; }
    .point {
        background: url('../../assets/images/ej/activeTimePoint.png') no-repeat;
        background-size: 100% 100%;
        width: 15px;
        height: 15px;
        margin: 0 30px;
        vertical-align: bottom;
        margin-top: 4px;
    }
    .right-text {
        color: #FBFBFB;
        margin-left: 30px;
        font-weight: 600;
        line-height: 30px;
        margin-top: -5px;
		font-weight: 400;
    }
    .time-line-content .right-intro {
        color: #FBFBFB;
        font-size: 14px;
        line-height: 40px;
		font-weight: 700;
    }
    .shuline {
        position: absolute;
        height: 80px;
        border-left: 1px solid #fff;
        top: 19px;
        left: 126px;
    }
    .meeting-jbjs {
        border: 8px solid #0350a0;
        box-sizing: border-box;
        width: 1000px;
        padding: 20px;
        color: #d6be98;
    }
    .detail-user-img { width: 100%; height: 200px;  }
    .index-quote-list-box { width: 1000px; height: 360px; overflow: hidden; box-sizing: border-box; border: 8px solid #0350a0; margin: 30px auto; }
    .index-quote-list-box .img-box { padding: 30px 10px 10px 10px;  }
    .index-quote-list-box p { line-height: 40px; font-size: 16px; color: #d6be98; }
    .meeting-zanzhu { width: 1000px; }
    .zanzhu-title,
    .zanzhu-subtitle { color: #fd7744; font-size: 18px; }
    .zanzhu-subtitle { color: #ffd79f; }
    .zanzhu-left,
    .zanzhu-center,
    .zanzhu-right { line-height: 35px; width: 100%; background: url('../../assets/images/ej/one.png') no-repeat; background-size: 100% 100%; margin: 10px 0; font-size: 14px; color: #fff;}
    .zanzhu-center { background: url('../../assets/images/ej/two.png') no-repeat; background-size: 100% 100%; }
    .zanzhu-right { background: url('../../assets/images/ej/three.png') no-repeat; background-size: 100% 100%; }
    .meeting-address { padding-bottom: 30px; }
    .address-bg {
        background: url('../../assets/images/ej/addressbg.png') no-repeat;
        background-size: 100% 100%;
        padding-top: 50px;
    }
    .address-bg img { width: 1000px; }
    .meeting-concat { width: 1000px; }
</style> 